import React, { useMemo } from 'react';
import OrganizationAnalyticsLineChart from './OrganizationAnalyticsLineChart';
import { formatTimeCategoriesByRange, mapIdsToLabels } from './chartUtils';

const OrganizationChatterPurchasesByTimeChart = ({ data, chatterLabelMap, dateRange, pending }) => {
  const { categories, series } = useMemo(
    () => ({
      categories: formatTimeCategoriesByRange(data?.time || [], dateRange),
      series: (data?.series || []).map(item => ({
        name: mapIdsToLabels([item.chatterId], chatterLabelMap)[0],
        data: item.purchaseCount || [],
      })),
    }),
    [data, chatterLabelMap, dateRange],
  );

  return (
    <OrganizationAnalyticsLineChart
      title="Purchases Over Time"
      subtitle="Purchase volume trend for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select one or more chatters to load purchase totals over time."
      valueType="number"
    />
  );
};

export default OrganizationChatterPurchasesByTimeChart;
